import React from 'react';
import { AlertTriangle, Info, Lightbulb } from 'lucide-react';
import { cn } from '@/lib/utils';

export type CalloutType = 'note' | 'caution' | 'tip';

const CONFIG: Record<
  CalloutType,
  { label: string; icon: React.ComponentType<{ className?: string }>; classes: string; labelClasses: string }
> = {
  note: {
    label: 'Note',
    icon: Info,
    classes: 'border-blue-500/30 bg-blue-500/10',
    labelClasses: 'text-blue-600 dark:text-blue-400',
  },
  caution: {
    label: 'Caution',
    icon: AlertTriangle,
    classes: 'border-red-500/30 bg-red-500/10',
    labelClasses: 'text-red-600 dark:text-red-400',
  },
  tip: {
    label: 'Tip',
    icon: Lightbulb,
    classes: 'border-emerald-500/30 bg-emerald-500/10',
    labelClasses: 'text-emerald-600 dark:text-emerald-400',
  },
};

export function Callout({
  type,
  label,
  children,
}: {
  type: CalloutType;
  /** Overrides the default type label (e.g. "Psst" instead of "Tip"). */
  label?: string;
  children: React.ReactNode;
}) {
  const { label: defaultLabel, icon: Icon, classes, labelClasses } = CONFIG[type];
  return (
    <div className={cn('rounded-lg border p-4 text-sm', classes)}>
      <div className={cn('mb-1 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide', labelClasses)}>
        <Icon className="h-3.5 w-3.5" />
        {label ?? defaultLabel}
      </div>
      <div className="text-foreground/90">{children}</div>
    </div>
  );
}
